export enum ApiKeyPairStatus {
  UNSET_API_KEY_PAIR_STATUS, // Do not use, needed because of proto3 limitations
  ACTIVE,
  COMPROMISED,
  DELETED,
}
